// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pin-solid';

export const Component = () => (
  <path d='M11.638 2.347V0L0 11.686h2.347l7.136 7.136 9.339-9.34-7.184-7.135Zm7.854 7.806-9.339 9.34 2.682 2.681v2.347l4.694-4.645 6.992 4.645-4.645-6.992 4.645-4.694h-2.347l-2.682-2.682Z' />
);

export const viewBox = '0 0 25 25';
